import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import { config } from '../../config.js'
import { exclamationPoint, verticalLogo } from '../../images/images.js'
import { Page, FullHeightCenteredFlexColumn, CenteredFlexColumn, Logo } from '../styles/Containers.js'
import BodyText, { BoldSpan, LargeTitle } from '../styles/Text.js'

const FixedContainer = styled.div`
  position: absolute;
  left: 5%;
  top: 50px;
  z-index: 10;
`

const ExclamationPoint = styled.img`
  width: 180px;
  align-items: center;
`

const SubContentContainer = styled(CenteredFlexColumn)`
  gap: 15px;
`

function ActionRequiredTemplate({ title, children, showLogo = false, showContact = false }) {
  return (
    <Page>
      {showLogo && (
        <FixedContainer>
          <Logo src={verticalLogo} />
        </FixedContainer>
      )}
      <FullHeightCenteredFlexColumn>
        <ExclamationPoint src={exclamationPoint} />
        <LargeTitle>{title}</LargeTitle>
        <SubContentContainer>{children}</SubContentContainer>
        {showContact && (
          <BodyText>
            Contact us at <BoldSpan>{config.foi.privacyTeamEmail}</BoldSpan> with any questions.
          </BodyText>
        )}
      </FullHeightCenteredFlexColumn>
    </Page>
  )
}

ActionRequiredTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  showLogo: PropTypes.bool,
  showContact: PropTypes.bool
}

export default ActionRequiredTemplate
